import React from 'react';
import './Line.module.scss';

export default function Line() {
  return <hr styleName="line" />;
}
